module.exports = __webpack_public_path__ + "static/media/so-stock--sheep3.6095275d.jpg";